import hydrate from './components/hydrate.js'
import { getElementTag } from '../../lib/get-element-tag.ts'
import { config } from './config.ts'
import '../../common/tittel/tittel.module.css'
import { VisMerElement } from '../../common/vis-mer/vis-mer.ts'

const tag = getElementTag(__APP_NAME__, config.moduleName, __APP_VERSION__)

function safeDefine(t: string, customElement: CustomElementConstructor) {
  if (customElements.get(t) === undefined) {
    customElements.define(t, customElement)
  }
}

class AppElement extends HTMLElement {
  connectedCallback() {
    hydrate(this, this.preloadedState)
    safeDefine('instuliv-vis-mer', VisMerElement)
  }

  get preloadedState() {
    return this.dataset.preloadedState ? JSON.parse(this.dataset.preloadedState) : null
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
